var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModeNight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dark_mode_FILL0_wght300_GRAD200_opsz24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03a-Dashboard---Date-&-Time-Picker",
    transform: "translate(-1004.000000, -339.000000)",
    fill: "current",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy",
    transform: "translate(415.000000, 224.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(411.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(178.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dark_mode_FILL0_wght300_GRAD200_opsz24",
    transform: "translate(0.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0284091,20 C7.24431818,20 4.87689394,19.0246212 2.92613636,17.0738636 C0.975378788,15.1231061 1.00929366e-15,12.7556818 1.00929366e-15,9.97159091 C1.00929366e-15,7.30113636 0.909090909,5.0094697 2.72727273,3.09659091 C4.54545455,1.18371212 6.77083333,0.151515152 9.40340909,5.04646829e-16 L9.65909091,5.04646829e-16 C9.77272727,5.04646829e-16 9.93371212,0.00946969697 10.1420455,0.0284090909 C9.72537879,0.596590909 9.39886364,1.25454545 9.1625,2.00227273 C8.92537879,2.75075758 8.80681818,3.48484848 8.80681818,4.20454545 C8.80681818,6.11742424 9.5030303,7.76022727 10.8954545,9.13295455 C12.2871212,10.5064394 13.9488636,11.1931818 15.8806818,11.1931818 C16.6382576,11.1931818 17.3390152,11.0890152 17.9829545,10.8806818 C18.6268939,10.6723485 19.2708333,10.3125 19.9147727,9.80113636 C19.9526515,9.85795455 19.9765152,9.98598485 19.9863636,10.1852273 C19.9954545,10.3837121 20,10.5208333 20,10.5965909 C19.8484848,13.2291667 18.8162879,15.4545455 16.9034091,17.2727273 C14.9905303,19.0909091 12.6988636,20 10.0284091,20 Z M10.0284091,17.5568182 C11.4109848,17.5568182 12.7037879,17.2018939 13.9068182,16.4920455 C15.1090909,15.7814394 16.0416667,14.8200758 16.7045455,13.6079545 C16.5909091,13.6079545 16.4583333,13.6125 16.3068182,13.6215909 C16.155303,13.6314394 16.0227273,13.6363636 15.9090909,13.6363636 C13.2765152,13.6363636 11.0276515,12.717803 9.1625,10.8806818 C7.29659091,9.04356061 6.36363636,6.81818182 6.36363636,4.20454545 C6.36363636,3.99621212 6.36818182,3.81628788 6.37727273,3.66477273 C6.38712121,3.51325758 6.40151515,3.39015152 6.42045455,3.29545455 C5.18939394,3.95833333 4.21893939,4.88636364 3.50909091,6.07954545 C2.79848485,7.27272727 2.44318182,8.57007576 2.44318182,9.97159091 C2.44318182,12.0738636 3.18636364,13.8636364 4.67272727,15.3409091 C6.15984848,16.8181818 7.94507576,17.5568182 10.0284091,17.5568182 Z",
    id: "Shape"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeNight);
export default __webpack_public_path__ + "static/media/mode_night.fef2445a93f7f009d71aba63cfde5615.svg";
export { ForwardRef as ReactComponent };